<template>
  <div v-if="this.logged_in === true">
    <v-app>
      <NavDrawer :roles="this.roles" :cur_role="this.cur_role" />
      <v-main class="mx-8">
          <router-view></router-view>
      </v-main>
    </v-app>
  </div>

  <div v-else>
    <!--
        You need to log in
        <v-btn @click="loginRedirect">Log In</v-btn>
        -->
  </div>
</template> 

<script>
// import Main from './components/Main';
// import Professional from './components/Professional';
// import Personal from './components/Personal';
// import TimeOff from './components/TimeOff';
// import Technology from './components/Technology'

import NavDrawer from "./components/NavDrawer";
import axios from "axios";


export default {
  name: "App",

  components: {
    NavDrawer,
  },

  data: () => ({
    tab: null,
    logged_in: false,
    // logged_in: true,

    roles: [],
    cur_role: null,

    professional_data: null,
    primary_subdept: [],
    secondary_subdept: [],

    suite_level: [
      "Mezzanine",
      "Lower Level",
      "Suite 200",
      "Suite 400",
      "Gymnasium",
      "First Floor",
      "Second Floor",
      "Third Floor",
      "Fourth Floor",
      "Reference Desk",
      "Booth",
      "Main Office",
    ],
    buildings: [
      "Alice Brown Early Learning Center",
      "Alumnae Hall",
      "Angello Alumni House",
      "Blodgett Hall",
      "Center for Recreation and Sports",
      "Chapman Hall",
      "Chasner Street",
      "Earle Hall A",
      "Earle Hall B",
      "Eddy Hall",
      "Grounds Maintenance Building",
      "Hagedorn Hall of Enterprise",
      "Harvey Hall",
      "Hauppauge Education and Conference Center",
      "Hudson Valley Center",
      "Hy Weinberg Center",
      "Klapper Center for Fine Arts",
      "Levermore Hall",
      "Linen Hall",
      "Manhattan Center",
      "Nexus Building",
      "Performing Arts Center",
      "Post Hall",
      "Post Hall Annex",
      "Public Safety Booth",
      "Residential Hall A (New Hall)",
      "Residential Hall B",
      "Ruth S. Harley University Center",
      "Science Building",
      "Social Work Building",
      "Swirlbul Library",
      "Waldo Hall",
      "Woodruff Hall",
    ],

    degree: [
      "EdD",
      "EdM",
      "MA",
      "MAPC",
      "MArch",
      "MAT",
      "MBA",
      "MDiv",
      "MEd",
      "MFA",
      "MHA",
      "MHR",
      "MIDS",
      "MLS",
      "MM",
      "MPA",
      "MPH",
      "MPhil",
      "MS",
      "MSC",
      "MSEd",
      "MSIE",
      "MSLIS",
      "MSN",
      "MSPH",
      "MSSW",
      "MSW",
      "MTS",
    ],
    credentials: [
      "ABECSW",
      "ABPN",
      "ABPP",
      "ACSW",
      "AGNP-C",
      "AGPCNP",
      "APRN",
      "ARCO",
      "BCBT",
      "BCD",
      "BCDT",
      "BCDV",
      "CACA",
      "CADAC",
      "CASAC",
      "CASAC-T",
      "CCADC",
      "CGP",
      "CMHC",
      "CNM",
      "CPA",
      "CPsych",
      "CRADC",
      "CRC",
      "CRNA",
      "CSW-C",
      "CSW-G",
      "DFAGPA",
      "DPNAP",
      "FAAN",
      "FAANP",
      "FAANP",
      "FAGPA",
      "FAPA",
      "FNP-BC",
      "FRCO",
      "IMH-DP",
      "IMH-E",
      "LCAT",
      "LCMHC",
      "LCPC",
      "LCSW",
      "LCSW-R",
      "LGSW",
      "LICSW",
      "LLD",
      "LMFT",
      "LMHC",
      "LMSW",
      "LMSW-ACP",
      "LPC",
      "LPC-S",
      "LPCC",
      "LPN",
      "LSATP",
      "LSP",
      "LSW",
      "MAC",
      "NCC",
      "NP",
      "PE",
      "PMHNP",
      "QDCS",
      "RN",
      "SHRM-CP",
      "SHRM-SCP",
    ],
    headshot: null,
    loader: null,
    loading: false,
/*
    nav_items: [
      { title: "Professional Info", icon: "mdi-bank", route: "/professional" },
      { title: "Personal Record", icon: "mdi-account", route: "/personal" },
      { title: "PTO and Leave", icon: "mdi-calendar-star", route: "/time-off" },
    ], */
  }),

  mounted() {
    axios.get('./remote-apis/user-api.php?cmd=cur_role')
      .then((response) => {
        this.cur_role = response.data.cur_role;             
      })
      .catch((err) => {
        window.console.log(err)
    })

    axios
      .get("./remote-apis/auth.php")
      .then((response) => {
        const json = response.data;
        if (json["msg"] == "authenticated") {
          axios
            .get('./remote-apis/user-api.php?cmd=role')
            .then((response) => {
              // window.console.log(response.data.ROOT.Idm.Primary_Role)
              this.roles.push(response.data.ROOT.Idm.Primary_Role)
              if (response.data.ROOT.Idm.Secondary_Role !== null) {
                this.roles.push(response.data.ROOT.Idm.Secondary_Role)
              }
              // window.console.log(JSON.stringify(this.roles))
             
              this.logged_in = true;
            })
            .catch((err) => {
              window.console.log(err)
            })
        } else {
          this.loginRedirect();
        }
      })
      .catch((error) => {
        window.console.error(error);
        this.loginRedirect();
      });
  },

  // watch: {
  //     loader () {
  //         const l = this.loader
  //         this[l] = !this[l]

  //         setTimeout(() => (this[l] = false), 3000)

  //         this.loader = null
  //     },
  // },

  methods: {
    loginRedirect() {
      var goto = "";
      var loc = window.location.hash;
      if (loc.includes("pto/balance"))
        goto = "pto/balance";
      else if (loc.includes("pto/manager"))
        goto = "pto/manager";
      else if (loc.includes("pto"))
        goto = "pto/request";
      else if (loc.includes("pto/compressed"))
        goto = "pto/compressed";
      else if (loc.includes("professional"))
        goto = "professional";
      else if (loc.includes("personal"))
        goto = "personal";
      else if (loc.includes('personal-student'))
        goto = 'personal-student'
      else if (loc.includes('parent-guardian'))
        goto = 'parent-guardian'
      else 
        goto = "";
      window.location = "./remote-apis/auth-redirect.php?goto=" + goto;
    },
  },
};
</script>

<style>
/* --- GRAPHIK - PRIMARY FONT ---- */
/*regular - normal/400*/




@font-face {
  font-family: "Graphik";
  src: url("//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-Regular.eot#")
      format("eot"),
    url("//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-Regular.woff")
      format("woff"),
    url("//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-Regular.woff2")
      format("woff2"),
    url("//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-Regular.ttf")
      format("truetype"),
    url("//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-Regular.svg#Graphik")
      format("svg");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "Graphik";
  src: url("//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-RegularItalic.eot#")
      format("eot"),
    url("//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-RegularItalic.woff")
      format("woff"),
    url("//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-RegularItalic.woff2")
      format("woff2"),
    url("//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-RegularItalic.ttf")
      format("truetype"),
    url("//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-RegularItalic.svg#Graphik")
      format("svg");
  font-weight: normal;
  font-style: italic;
}
/*light - 300*/

@font-face {
  font-family: "Graphik";
  src: url("//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-Light.eot#")
      format("eot"),
    url("//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-Light.woff")
      format("woff"),
    url("//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-Light.woff2")
      format("woff2"),
    url("//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-Light.ttf")
      format("truetype"),
    url("//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-Light.svg#Graphik")
      format("svg");
  font-weight: 300;
  font-style: normal;
}

@font-face {
  font-family: "Graphik";
  src: url("//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-LightItalic.eot#")
      format("eot"),
    url("//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-LightItalic.woff")
      format("woff"),
    url("//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-LightItalic.woff2")
      format("woff2"),
    url("//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-LightItalic.ttf")
      format("truetype"),
    url("//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-LightItalic.svg#Graphik")
      format("svg");
  font-weight: 300;
  font-style: italic;
}
/*semibold - 600*/

@font-face {
  font-family: "Graphik";
  src: url("//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-Semibold.eot#")
      format("eot"),
    url("//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-Semibold.woff")
      format("woff"),
    url("//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-Semibold.woff2")
      format("woff2"),
    url("//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-Semibold.ttf")
      format("truetype"),
    url("//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-Semibold.svg#Graphik")
      format("svg");
  font-weight: 600;
  font-style: normal;
}

@font-face {
  font-family: "Graphik";
  src: url("//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-SemiboldItalic.eot#")
      format("eot"),
    url("//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-SemiboldItalic.woff")
      format("woff"),
    url("//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-SemiboldItalic.woff2")
      format("woff2"),
    url("//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-SemiboldItalic.ttf")
      format("truetype"),
    url("//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-SemiboldItalic.svg#Graphik")
      format("svg");
  font-weight: 600;
  font-style: italic;
}
/*bold - bold/700*/

@font-face {
  font-family: "Graphik";
  src: url("//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-Bold.eot#")
      format("eot"),
    url("//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-Bold.woff")
      format("woff"),
    url("//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-Bold.woff2")
      format("woff2"),
    url("//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-Bold.ttf")
      format("truetype"),
    url("//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-Bold.svg#Graphik")
      format("svg");
  font-weight: bold;
  font-style: normal;
}

@font-face {
  font-family: "Graphik";
  src: url("//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-BoldItalic.eot#")
      format("eot"),
    url("//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-BoldItalic.woff")
      format("woff"),
    url("//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-BoldItalic.woff2")
      format("woff2"),
    url("//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-BoldItalic.ttf")
      format("truetype"),
    url("//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-BoldItalic.svg#Graphik")
      format("svg");
  font-weight: bold;
  font-style: italic;
}
/*medium - 500*/

@font-face {
  font-family: "Graphik";
  src: url("//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-Medium.eot#")
      format("eot"),
    url("//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-Medium.woff")
      format("woff"),
    url("//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-Medium.woff2")
      format("woff2"),
    url("//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-Medium.ttf")
      format("truetype"),
    url("//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-Medium.svg#Graphik")
      format("svg");
  font-weight: 500;
  font-style: normal;
}

@font-face {
  font-family: "Graphik";
  src: url("//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-MediumItalic.eot#")
      format("eot"),
    url("//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-MediumItalic.woff")
      format("woff"),
    url("//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-MediumItalic.woff2")
      format("woff2"),
    url("//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-MediumItalic.ttf")
      format("truetype"),
    url("//www.adelphi.edu/wp-content/themes/adelphi.edu/fonts/Graphik-MediumItalic.svg#Graphik")
      format("svg");
  font-weight: 500;
  font-style: italic;
}

.v-application {
  font-family: "Graphik", "Roboto", Arial, Helvetica, sans-serif !important;
}

.v-application p {
  margin-bottom: 1.4em;
  font-family: "Graphik", Arial, Helvetica, sans-serif;
  color: #504941;
  font-size: 1em;
  line-height: 1.8em;
  font-weight: normal;
}

.v-application p.instruction {
  margin-bottom: 0;
  margin-top: -1em;
  font-family: "Graphik", Arial, Helvetica, sans-serif;
  color: #504941;
  font-size: 0.85em;
  line-height: 1.8em;
  font-weight: normal;
  font-style: italic;
}

.v-application a {
  text-decoration: none;
  color: #000 !important;
  font-weight: 600;
  -webkit-transition: background 0.25s, border 0.25s, color 0.25s;
  transition: background 0.25s, border 0.25s, color 0.25s;
}

.v-application a:hover,
.v-application a:focus {
  color: #504941;
}

.v-application a img {
  border-bottom-width: 0 !important;
  border-bottom-color: none !important;
}

.v-application a:hover img {
  border-bottom-width: 0 !important;
  border-bottom-color: none !important;
}

.v-application b a,
.v-application strong a {
  font-weight: bold;
}

/* Overriding ugly main inline style */
/* main {
  padding: 56px 0 0 !important;
} */

/* Brought in from PTO Component */

a.bold-link {
  text-decoration: underline !important;
  text-decoration-color: #FFB500 !important;
  text-decoration-thickness: 2px !important;
}

a.bold-link {
transition: color .25s, background .25s,text-decoration .25s,-webkit-text-decoration .25s !important;
}

a.bold-link:hover, a.bold-link:focus {
color: #7a6754 !important;
}

.admin a {
  text-decoration: underline;
  font-weight: 400;
}

.imp {
  color: red;
}

.iframe-container {
  overflow: hidden;
  padding-top: 56.25%; /* 16:9*/
  position: relative;
}

.iframe-container iframe {
   border: 0;
   height: 100%;
   left: 0;
   position: absolute;
   top: 0;
   width: 100%;
}

.v-expansion-panel-header {
    text-transform: none !important;
    padding-left: 8px;
    /* background: #ffb500; */
    color: #000000 !important;
}

.alert_red {
  color: #e31c3d !important;
  border-color: #e31c3d !important;
  font-weight: 700;
}

/* End PTO Component */

.v-text-field .v-counter {
  margin-bottom: 1.1em;
}

.v-tabs {
  margin-bottom: 1em;
}

.v-tabs-slider-wrapper {
  height: 2px;
  left: 153px;
  width: 116px;
  color: rgb(255, 181, 0);
}

.v-application .primary--text {
  color: #7a6855 !important;
  caret-color: #7a6855 !important;
}

.v-text-field fieldset,
.v-text-field .v-input__control {
  color: rgba(0, 0, 0, 0.3) !important;
}

.v-btn {
  border-radius: 0;
}

.v-label,
span.label {
  font-size: 1.09em;
  line-height: 1.7;
  font-weight: 700 !important;
  color: black !important;
}

span.black-text {
  color: #000;
}

span.label-not-strong {
  font-weight: normal !important;
  color: #000 !important;
  display: block;
  line-height: 1.8em;
  font-weight: normal;
  font-style: italic;
  font-size: 0.8em;
}

.v-btn--outlined .v-btn__content .v-icon,
.v-btn--round .v-btn__content .v-icon {
  color: #7a6855;
}

.v-tooltip__content {
  background: rgba(0, 0, 0, 0.8);
}

div.flexbox {
  display: flex;
  align-items: center;
}

.theme--light.v-data-table thead tr th {
  font-size: 1.09em;
  line-height: 1.7;
  font-weight: 700 !important;
  color: black !important;
}

.v-data-table td {
  height: 50px;
  color: #504941;
  font-size: 1em !important;
  line-height: 1.8em;
  font-weight: normal;
  vertical-align: top;
  padding: 1em;
}

.v-data-table td div,
.v-data-table table td div {
  color: #504941;
  font-size: 1em !important;
  line-height: 2.3em;
  font-weight: normal;
}

.v-data-table table td div {
  color: #504941;
  font-size: 1em !important;
  line-height: 2.2em;
  font-weight: normal;
  vertical-align: top;
  top: 50px;
}

.theme--light.v-data-table
  tbody
  tr:hover:not(.v-data-table__expanded__content) {
  background-color: rgba(0, 0, 0, 0.03);
}

.v-expansion-panel::before {
  border-radius: 0px;
}

.v-application--is-ltr .v-expansion-panel-header {
  text-align: left;
  font-family: "Graphik", sans-serif !important;
  font-weight: 500 !important;
  color: #7a6855 !important;
  font-size: 1rem !important;
  letter-spacing: 0.0625rem !important;
  text-transform: uppercase !important;
}

.gold {
  background-color: #ffb500;
}

.light-brown {
  background-color: #f1efed;
}

.brown-text {
  color: #4f2c1d;
}

.menu-btn {
  background-color: #000 !important;
  color: #fff !important;
}

.menu-btn:hover {
  background-color: #000 !important;
  color: #ffb500 !important;
  text-decoration: underline;
}

.v-expansion-panel-content__wrap {
    padding: 0 !important;
}

.v-content__wrap {
    -webkit-box-flex: auto !important;
    -ms-flex: auto !important;
    flex: auto !important;
    max-width: 100%;
    position: relative;
}

@media only screen and (max-width: 600px) {
  .row {
    padding-bottom: 0;
  }
  div.row ~ h3 {
    margin-top: 1.25em;
  }
  div.row ~ h4 {
    margin-top: 1.25em;
  }
  h1 {
    font-size: 2em;
    line-height: 1.25em;
  }
  h2 {
    font-size: 1.8em;
    line-height: 1.15384615em;
  }
  h3 {
    font-size: 1.75em;
    line-height: 1.15384615em;
    margin: 0 0 0.3em 0;
  }
  div.col-sm-3.col-12 {
    margin: 0.5em 0 -0.4em 0;
  }
}

@media (min-width: 1264px) {
  /* .container {
    max-width: 960px;
  } */
  .v-content__wrap {
    max-width: 1185px !important;
    margin: 0 !important;
  }
}

div.col>*:first-child {
    margin-top: 0;
}

h1 {
    font-family: Graphik, Ariel, sans-serif;
    font-weight: bold;
    color: #121212;
    font-size: 42px;
    line-height: 1.33em;
    margin-bottom: 1rem;

    @media (min-width: 740px) {
        font-weight: 700;
        font-size: 42px;
        line-height: 1.23em;
        margin-bottom: 1.6rem;
    }
}

h2 {
    font-family: Graphik, Ariel, sans-serif;
    font-weight: normal !important;
    color: #121212;
    font-size: 30px;
    line-height: 1.39em;
    margin: 50px 0 10px;

    @media (min-width: 740px) {
        font-size: 30px;
        line-height: 1.23em;

    }
}

h3 {

    font-family: Graphik, Ariel, sans-serif;
    font-weight: normal;
    font-size: 18px;
    line-height: 1.625;
    margin: 50px 0 10px;
    color: #7a6754;

    @media (min-width: 740px) {
        font-size: 18px;
        line-height: 1.72727;
    }
}

h2+h3 {
    margin: 32px 0 5px;
}


.v-label,
span.label {
    color: #121212;
    font-size: 1rem;
    font-weight: 600 !important;
    line-height: 1.4rem;
}

.v-btn:not(.v-btn--round).v-size--x-large {
    height: 52px;
    min-width: 92px;
    padding: 0 23.1111111111px;
    margin: 2em 0;
}

/*
@import "https://webbot.mainstay.com/static/css/webchat.css";

._admithub_embed-container .mr-3, ._admithub_embed-container .mx-3 {
    font-family: "Graphik", "Roboto", Arial, Helvetica, sans-serif !important;
    font-weight: 400 !important;
}
*/

.page-heading {
  font-family: Graphik, Arial, sans-serif;
  font-weight: 500;
  font-size: 40px;
  margin: 0px;
  padding: 0px;
}
.body-heading {
  font-family: Graphik, Arial, sans-serif;
  font-weight: 500;
  font-size: 30px;
  margin: 0px;
  color: #7a6754;
}
.v-input {
  margin: 0px !important;
  padding: 0px !important;
}

h1, h2, h3 {
  /* font-weight: 700 !important; */
  padding: 5px !important;
  padding-top: 12px !important;
  margin: 5px !important;
}

.row {
  padding-bottom: 0px !important;
  margin: 0px !important;
}

.col-xl, .col-xl-auto, .col-xl-12, .col-xl-11, .col-xl-10, .col-xl-9, .col-xl-8, .col-xl-7, .col-xl-6, .col-xl-5, .col-xl-4, .col-xl-3, .col-xl-2, .col-xl-1, .col-lg, .col-lg-auto, .col-lg-12, .col-lg-11, .col-lg-10, .col-lg-9, .col-lg-8, .col-lg-7, .col-lg-6, .col-lg-5, .col-lg-4, .col-lg-3, .col-lg-2, .col-lg-1, .col-md, .col-md-auto, .col-md-12, .col-md-11, .col-md-10, .col-md-9, .col-md-8, .col-md-7, .col-md-6, .col-md-5, .col-md-4, .col-md-3, .col-md-2, .col-md-1, .col-sm, .col-sm-auto, .col-sm-12, .col-sm-11, .col-sm-10, .col-sm-9, .col-sm-8, .col-sm-7, .col-sm-6, .col-sm-5, .col-sm-4, .col-sm-3, .col-sm-2, .col-sm-1, .col, .col-auto, .col-12, .col-11, .col-10, .col-9, .col-8, .col-7, .col-6, .col-5, .col-4, .col-3, .col-2, .col-1 {
  padding: 4px !important;
}
</style>